import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'NATR',
  version: 1,
  label: 'Normalized Average True Range',
  pane: 'sub',
  category: 'volatility',
  series: 'normal',
  precision: 2,
  order: 20,
  // TA-Lib allows a period of 1 (then, like ATR, it is the raw true range).
  inputs: [period('timeperiod', 14, 'Length', 1)],
  outputs: [line('natr', 'NATR', COLOR.orange)],
  talib: { functions: ['NATR'], expr: 'NATR(high, low, close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
